// NIGHT-DIRECTSTAFF-2026-10-24 §5: voicemail / missed-call leads and re-engagement steps (the agents' NIGHT-AGENTS-2026-10-24 §1 / §3;
// shapes from the agents window, 10-24):
//   alerts      agent_notifications reason 'voicemail_received' | 'missed_call' (a facility-sounding one comes as 'facility_request' and
//               is already a Today facility row); the detail ends "… — texted back; a recruiter call back by 3 PM ET today lead_id=<uuid>"
//               where the text-back part is "texted back" | "text-back queued for the send window" | "no text-back (<reason>)".
//               "Called back" = the alert handled (handled_at / status not open) -- what the CRM's Mark handled writes.
//   timeline    activity_log type 'voicemail' | 'missed_call': "Voicemail · <transcript> · lead_id=<uuid>" (staff only), "Missed call ·
//               no voicemail left · lead_id=<uuid>"; a known candidate's rows carry candidate_id and no lead_id.
//               type 'reengage': "Re-engagement · day 14 · text · lead_id=<uuid>" (day 14 / 45 / 90 = steps 1 / 2 / 3; text | email).
export const VOICE_REASONS = ['voicemail_received', 'missed_call'];
export const VOICE_TYPES = ['voicemail', 'missed_call'];
export const REENGAGE_TYPE = 'reengage';
const s = (v) => (v === null || v === undefined ? '' : String(v));
const LEAD_RE = /\s*lead_id=([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\s*$/i;
const t = (iso) => { const x = Date.parse(iso || ''); return Number.isNaN(x) ? null : x; };

/** the alert's text-back words: 'texted back' | 'text-back queued' | 'no text-back (…)' | '' */
export function textBackOf(detail) {
  const d = s(detail).replace(LEAD_RE, '');
  if (/no text-back \(([^)]*)\)/i.test(d)) return `no text-back (${/no text-back \(([^)]*)\)/i.exec(d)[1]})`;
  if (/text-back queued/i.test(d)) return 'text-back queued';
  if (/texted back/i.test(d)) return 'texted back';
  // recruiter-agent's fourth form: `text-back <status>` (e.g. a send that failed)
  if (/text-back ([a-z_-]+)/i.test(d)) return `text-back ${/text-back ([a-z_-]+)/i.exec(d)[1]}`;
  return '';
}
const isOpen = (n) => !!n && s(n.status || 'open') === 'open' && !n.handled_at;
const isTestLead = (l) => !!(l && (l.test_marked_at || l.merged_into || l.spam_marked_at));

/** Today's rows: one per lead (or per alert when it names no lead), oldest first -> [{ key, alertIds, kind, leadId, lead, phone, at, hours, textBack, words }] */
export function voiceRows({ notifications = [], leads = [], now = Date.now() } = {}) {
  const byId = new Map((leads || []).map((l) => [s(l.id).toLowerCase(), l]));
  const groups = new Map();
  for (const n of notifications || []) {
    if (!isOpen(n) || !VOICE_REASONS.includes(s(n.reason))) continue;
    const m = LEAD_RE.exec(s(n.detail)); const leadId = m ? m[1].toLowerCase() : null;
    const lead = leadId ? byId.get(leadId) || null : null;
    if (isTestLead(lead)) continue;
    const key = leadId || `alert:${n.id}`;
    const g = groups.get(key) || { key, alertIds: [], kind: s(n.reason) === 'missed_call' ? 'missed_call' : 'voicemail', leadId, lead, phone: s(n.candidate_phone) || (lead && lead.phone) || '',
      at: n.created_at, textBack: '', words: '' };
    g.alertIds.push(n.id);
    if (s(n.reason) === 'voicemail_received') g.kind = 'voicemail';
    if (!g.textBack) g.textBack = textBackOf(n.detail);
    if (!g.words) g.words = s(n.detail).replace(LEAD_RE, '').replace(/\s*—\s*(texted back|text-back|no text-back)[\s\S]*$/i, '').trim();
    if (t(n.created_at) !== null && t(n.created_at) < t(g.at)) g.at = n.created_at;
    groups.set(key, g);
  }
  return [...groups.values()].map((g) => ({ ...g, hours: t(g.at) === null ? null : Math.max(0, Math.floor((now - t(g.at)) / 3600e3)) }))
    .sort((a, b) => (t(a.at) ?? 0) - (t(b.at) ?? 0));
}

/** activity row -> { title, line, detail, tone? } | null */
export function voiceEntry(a, notifications = []) {
  const type = s(a && a.type); const note = s(a && a.note);
  if (type === 'voicemail') {
    const body = note.replace(LEAD_RE, '').replace(/\s*·\s*$/, '').replace(/^Voicemail\s*·\s*/, '');
    return { title: 'Voicemail', line: body.split('\n')[0].slice(0, 160), detail: body };
  }
  if (type === 'missed_call') {
    const m = LEAD_RE.exec(note);
    const alert = m ? (notifications || []).find((n) => VOICE_REASONS.includes(s(n.reason)) && s(n.detail).toLowerCase().includes(m[1].toLowerCase())) : null;
    const tb = alert ? textBackOf(alert.detail) : '';
    return { title: tb === 'texted back' ? 'Missed call — text sent' : 'Missed call', line: ['No voicemail left', tb && tb !== 'texted back' ? tb : ''].filter(Boolean).join(' · '), detail: '' };
  }
  if (type === REENGAGE_TYPE) {
    const m = /^Re-engagement · day (\d+) · (text|email)/.exec(note);
    if (!m) return null;
    const step = { 14: 1, 45: 2, 90: 3 }[Number(m[1])];
    return { title: `Re-engagement step ${step || '?'} sent`, line: `Day ${m[1]} · by ${m[2]}`, detail: '' };
  }
  return null;
}
